export { SymbolStore } from "@cogo/runtime-v2"
